import React, {Fragment} from "react";
import './c16_consiglio_di_amministrazione.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {insertHtml} from "../../utils/dom";

class ConsiglioDiAmministrazione extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            btnHidden: '',
            dataIndex: null,
            disabled: false,
            slideIndex: 1,
            updateCount: 0
        };

        this.requireInternationalization = true;
    };

    showContent = (dataIndex, btnValue, disabled) => {
        this.setState({
            isHidden: !this.state.isHidden,
            btnHidden: btnValue,
            dataIndex: dataIndex,
            disabled: disabled
        });
    };

    internationalComponentRender(data, t) {

        const settings = {
            dots: false,
            arrows: false,
            infinite: false,
            centerMode: true,
            centerPadding: "60px",
            speed: 500,
            swipeToSlide: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            afterChange: (index) => this.setState(state => ({slideIndex: state.updateCount + (index + 1)})),
            beforeChange: (current, next) => this.setState({slideIndex: next})
        };
        return (
            !isMobileOnly ? // che amarezza
                <div id="consigli-di-ammin" className="c16-cda auto-margins">
                    <div className="consigli-di-ammin-title">{data.title}</div>
                    <div className="container">
                        <div className="row justify-content-between">
                            {data.item && data.item.map((persona, index) => (
                                <Fragment key={index}>
                                    <div id="consigli-di-ammin">
                                        <div className="col-6">
                                            <div className="consigli-di-ammin-card container-fluid">
                                                <div className="row">
                                                    <img className="consigli-di-ammin-img col" src={persona.photo}
                                                         alt="Luiss.it"/>
                                                    <div className="col">
                                                        <div className="consigli-di-ammin-name">{persona.name}</div>
                                                        <div className="consigli-di-ammin-position">{persona.position}</div>
                                                        <button
                                                            className={'consigli-di-ammin-btn' + this.state.btnHidden}
                                                            disabled={this.state.disabled}
                                                            onClick={() => this.showContent(index, '-hidden', true)}>
                                                            {t("C16 button view profile")}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {((!this.state.isHidden && index === this.state.dataIndex - (this.state.dataIndex % 2) + 1) ||
                                        (!this.state.isHidden && index + 1 === this.state.dataIndex - (this.state.dataIndex % 2) + 1 && index + 1 === data.item.length)) &&
                                    <div className="consigli-di-ammin-modal">
                                        <button className="consigli-di-ammin-modal-btn"
                                                onClick={() => this.showContent(this.state.dataIndex, '', false)}>&times;</button>
                                        <div className="consigli-di-ammin-modal-text"> 
                                        {/*{...insertHtml(data.item[this.state.dataIndex].bio)}*/} 
                                              <a href={"/faculty/"+data.item[this.state.dataIndex].matricola}>Profilo</a> 
                                              </div>
                                        {data.item[this.state.dataIndex].contacts &&
                                        <div className="consigli-di-ammin-modal-contact">{data.item[this.state.dataIndex].contacts}</div>
                                        }
                                        <div className="consigli-di-ammin-modal-email">
                                            {data.item[this.state.dataIndex].email &&
                                            <a href={'mailto:' + data.item[this.state.dataIndex].email}>{data.item[this.state.dataIndex].email}</a>
                                            }
                                        </div>
                                    </div>
                                    }
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                :
                /* -- Mobile Version -- */
                <div id="consigli-di-ammin-mob">
                    <div className="consigli-di-ammin-title">{data.title}</div>
                    <div className="slider-fraction">
                        <span>{this.state.slideIndex}</span><span>/{data.item.length}</span>
                    </div>
                    <Slider {...settings}>
                        {data.item && data.item.map((persona, index) => (
                            <div key={index}>
                                <img className="consigli-di-ammin-img" src={persona.photo} alt={persona.name}/>
                                <div className="consigli-di-ammin-name">{persona.name}</div>
                                <div className="consigli-di-ammin-position">{persona.position}</div>
                                <button className="consigli-di-ammin-btn" onClick={() => this.showContent(index)}>
                                    {t("C16 button view profile")}
                                </button>
                            </div>
                        ))}
                    </Slider>
                    {!this.state.isHidden &&
                    <div className="consigli-di-ammin-modal">
                        <button className="consigli-di-ammin-modal-btn"
                                onClick={() => this.showContent(0)}>&times;</button>
                        <img className="consigli-di-ammin-modal-img" src={data.item[this.state.dataIndex].photo}
                             alt={data.item[this.state.dataIndex].alt}/>
                        <div className="consigli-di-ammin-modal-name">
                            {data.item[this.state.dataIndex].name}
                        </div>
                        <div className="consigli-di-ammin-modal-position">
                            {data.item[this.state.dataIndex].position}
                        </div>
                        <div className="consigli-di-ammin-modal-text">
                           {/*}  {...insertHtml(data.item[this.state.dataIndex].bio)}*/} 
                             <a href={"/faculty/"+data.item[this.state.dataIndex].matricola}>Profilo</a> 
                             </div>
                        {data.item[this.state.dataIndex].contacts &&
                        <div className="consigli-di-ammin-modal-contact">{data.item[this.state.dataIndex].contacts}</div>
                        }
                        <div className="consigli-di-ammin-modal-email">
                            {data.item[this.state.dataIndex].email &&
                            <a href={'mailto:' + data.item[this.state.dataIndex].email}>{data.item[this.state.dataIndex].email}</a>
                            }
                        </div>
                    </div>
                    }
                </div>
        )
    }
}

export default ConsiglioDiAmministrazione;
